module.exports = "/assets/data/982a23e316348ca2c09b89a143a55229-CR2.data.json";